import React from "react";
import { Card } from "../modules/Sites";

export function SiteCardPage(props) {
  return <Card {...props} />;
}
